module.exports = ".msg-textarea{\r\n    width: 75%;\r\n    min-height: 125px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/help-info/help-info.component.css
// module id = ./src/app/pages/help-info/help-info.component.css
// module chunks = main